export default {
  title: "Tutellus POAPs",
  description: "Insignias on-chain de los eventos y formaciones de Tutellus, en tu wallet.",
  back: "Volver",
  card: {
    mint: "Mintear",
    detail: "Ver detalle",
    enterCode: "Código del evento",
    description: "Descripción",
    detailsTitle: "Detalles",
    openSea: "Ver en OpenSea",
    share: "Compartir",
    copyText: "Copiar enlace",
    metadata: {
      contract: "Contrato",
      tokenStandard: "Estándar",
      blockchain: "Blockchain",
      tokenId: "Token ID",
      type: "Tipo",
      minted: "Minteado",
    },
  },
  page: {
    titleMint: "Haz Mint de tu POAP",
    mintCTA: "Mintear POAP",
    mintingCTA: "Minteando...",
    connectWallet: "Conectar Wallet",
    footerInfo: {
      title: "Cómo conseguir este POAP",
    },
  },
}
